import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { REVEAL, SUBURBS } from "@/lib/site";

export const ServiceArea = () => (
  <section id="coverage" data-testid="coverage-section" className="border-b border-black/10 bg-white py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-5">
      <motion.div variants={REVEAL} initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.4 }} className="mb-12 max-w-2xl">
        <span className="kicker text-[#1F7A6B]">Coverage</span>
        <h2 className="mt-3 font-heading text-3xl md:text-5xl leading-tight text-[#171717]">
          Servicing all of Sydney
        </h2>
        <p className="mt-4 text-lg leading-relaxed text-[#171717]/70">
          From the CBD to the outer suburbs — if you're stranded in Sydney, a Fuel Hero is never far away.
        </p>
      </motion.div>

      <div className="grid gap-6 lg:grid-cols-[1fr_1.1fr]">
        <motion.div
          variants={REVEAL}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="rounded-2xl border border-black/10 bg-[#F5F3EF] p-6 shadow-soft-sm"
          data-testid="suburb-list"
        >
          <div className="flex flex-wrap gap-2">
            {SUBURBS.map((s) => (
              <span
                key={s}
                className="flex items-center gap-1.5 rounded-full border border-black/10 bg-white px-3 py-1.5 text-sm font-medium text-[#171717]/80"
              >
                <MapPin strokeWidth={2} className="h-3.5 w-3.5 text-[#1F7A6B]" /> {s}
              </span>
            ))}
            <span className="flex items-center rounded-full bg-[#22303C] px-3 py-1.5 text-sm font-medium text-white">
              + everywhere in between
            </span>
          </div>
        </motion.div>

        <motion.div
          variants={REVEAL}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, amount: 0.2 }}
          className="overflow-hidden rounded-2xl border border-black/10 shadow-soft-sm"
          data-testid="service-map"
        >
          <iframe
            title="Sydney Service Area Map"
            src="https://www.google.com/maps?q=Sydney%20NSW%20Australia&z=10&output=embed"
            className="h-[360px] w-full"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </motion.div>
      </div>
    </div>
  </section>
);
